import {useEffect, useState} from 'react'
import {ISelectOption} from '../utils/core/_model'
import axios from 'axios'
import {GET_SUBMENU_URL} from '../modules/menu-management/sub-menu/SubmenuList'
import {ISubmenu} from '../modules/menu-management/sub-menu/_model'

const useSubmenuList = () => {
  const [optionsSubmenu, setOptionsSubmenu] = useState<ISelectOption[]>([])
  const [options, setOptions] = useState<ISubmenu[]>([])

  useEffect(() => {
    const getLinkList = async () => {
      try {
        const response = await axios.get<{data: ISubmenu[]}>(GET_SUBMENU_URL)
        const data = await response.data
        const result = await data.data
        // console.log(result)
        const formatted = result.map((link) => ({
          id: link.id_submenu,
          value: link.submenu_name,
          label: link.submenu_name,
        }))
        setOptions(result || [])
        setOptionsSubmenu(formatted || [])
      } catch (error) {
        console.log(error)
      }
    }

    getLinkList()
  }, [])

  return {
    optionsSubmenu,
    options,
  }
}

export default useSubmenuList
